/* RRM dev build — PDP behaviours. v1 2026-09-04 (dots, sticky pill) + v2 design-spec build (chip in-place swap §F1,
   add-to-cart feedback §F3). No dependencies. */
(function () {
  'use strict';
  var PILL_OFFSET = 66; /* pill 54px + 12px clearance: also applied to the Shopify Inbox launcher host */
  var SWAP_TIMEOUT = 2000;

  /* ---------- B2e: pager dots follow the theme's slider-component 'slideChanged' event ---------- */
  function bindDots(root) {
    (root || document).querySelectorAll('[data-rrm-dots]').forEach(function (dots) {
      if (dots.__rrmBound) return;
      var slider = document.getElementById(dots.getAttribute('data-rrm-dots'));
      if (!slider) return;
      dots.__rrmBound = true;
      slider.addEventListener('slideChanged', function (e) {
        var i = ((e.detail && e.detail.currentPage) || 1) - 1;
        dots.querySelectorAll('.rrm-gallery-dots__dot').forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      });
    });
  }
  bindDots();

  /* ---------- B3 / Fix 1: sticky ATC pill — visible once the in-page ATC's bottom is above the viewport top.
     Geometry is read on a rAF-throttled scroll/resize listener (IntersectionObserver misses fast flings).
     The watched form is re-queried on every tick so a chip swap (which re-renders the buy box) needs no re-wiring. ---------- */
  document.querySelectorAll('[data-rrm-sticky-atc]').forEach(function (bar) {
    var formId = bar.getAttribute('data-watch');
    var mql = window.matchMedia('(max-width: 989px)');
    var ticking = false;
    function target() { var f = document.getElementById(formId); return f ? (f.querySelector('[name="add"]') || f) : null; }
    function sync() {
      ticking = false;
      var t = target();
      if (!t) return;
      var r = t.getBoundingClientRect();
      var show = r.bottom <= 0 && mql.matches;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('rrm-sticky-visible', show);
      var chat = document.querySelector('shopify-chat');
      if (chat) chat.style.transform = show ? 'translateY(-' + PILL_OFFSET + 'px)' : '';
    }
    function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(sync); } }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    if (mql.addEventListener) { mql.addEventListener('change', request); } else { mql.addListener(request); }
    sync();
    bar.__rrmSync = sync;

    /* mirror the in-page button's label (first text node only — the price span is rendered on the pill's left) and disabled state */
    function mirror() {
      var t = target();
      var stickyBtn = bar.querySelector('button');
      if (!t || !stickyBtn) return;
      stickyBtn.disabled = t.disabled;
      var label = bar.querySelector('[data-rrm-sticky-label]');
      var span = t.querySelector('[data-rrm-atc-label]') || t.querySelector('span');
      if (label && span) {
        var txt = (span.firstChild && span.firstChild.nodeType === 3) ? span.firstChild.textContent : span.textContent;
        label.textContent = txt.trim();
      }
    }
    function observe() {
      var t = target();
      if (!t || !('MutationObserver' in window)) return;
      if (bar.__rrmMo) bar.__rrmMo.disconnect();
      bar.__rrmMo = new MutationObserver(mirror);
      bar.__rrmMo.observe(t, { attributes: true, childList: true, subtree: true, characterData: true });
      mirror();
    }
    observe();
    bar.__rrmObserve = observe;
  });

  /* ---------- F3: add-to-cart feedback — "Adding…" on submit, "Added" + tick for 1.2s on success, then the theme's
     cart notification (already opened by product-form.js) stays. Shared form, so the pill mirrors the same label. ---------- */
  function bindAtcFeedback() {
    var form = document.querySelector('.rrm-pdp form[data-type="add-to-cart-form"]');
    if (!form || form.__rrmFb) return;
    form.__rrmFb = true;
    var btn = form.querySelector('[name="add"]');
    var span = btn && btn.querySelector('[data-rrm-atc-label]');
    if (!btn || !span || !('MutationObserver' in window)) return;
    form.addEventListener('submit', function () {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var original = span.innerHTML;
      span.textContent = 'Adding…';
      var mo = new MutationObserver(function () {
        if (btn.classList.contains('loading')) return;
        mo.disconnect();
        var pf = form.closest('product-form');
        var err = pf && pf.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (err) { span.innerHTML = original; return; }
        span.textContent = 'Added';
        btn.classList.add('is-added');
        setTimeout(function () { span.innerHTML = original; btn.classList.remove('is-added'); }, 1200);
      });
      mo.observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  }
  bindAtcFeedback();

  /* ---------- F1: chip tap swaps the product in place.
     Data: sibling products from custom.linked_products_dropdown (chips carry data-handle / data-url / data-colour).
     Mechanism: the sibling's main-product section is fetched through the Section Rendering API
     (/products/{handle}?section_id=…) and the `.product` grid (gallery + buy box) is replaced wholesale, so the
     theme's media-gallery / slider / product-form custom elements re-initialise on insertion — a `.js` payload would have
     left the desktop thumbnail rail and the variant form unbound. Preload on pointerenter/touchstart; ring moves at
     once; gallery aria-busy + 40% opacity while loading; >2s or any error = full navigation (never a dead chip). ---------- */
  var cache = {};
  function fetchSection(url, sectionId) {
    var key = url.split('?')[0];
    if (!cache[key]) {
      cache[key] = fetch(key + '?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); });
      cache[key].catch(function () { delete cache[key]; });
    }
    return cache[key];
  }
  function preloadLead(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var img = doc.querySelector('.product__media-list .is-active img') || doc.querySelector('.product__media-list img');
      if (!img) return;
      var i = new Image();
      if (img.getAttribute('sizes')) i.sizes = img.getAttribute('sizes');
      if (img.getAttribute('srcset')) i.srcset = img.getAttribute('srcset');
      i.src = img.getAttribute('src');
    } catch (e) { /* preload is best-effort */ }
  }
  function swapTo(chip) {
    var section = chip.closest('.rrm-pdp') || document.querySelector('.rrm-pdp');
    if (!section) { window.location.href = chip.getAttribute('data-url'); return; }
    var sectionId = section.getAttribute('data-section');
    var url = chip.getAttribute('data-url');
    var handle = chip.getAttribute('data-handle');
    var colour = chip.getAttribute('data-colour');
    var list = chip.closest('[data-rrm-chips]');
    var gallery = section.querySelector('media-gallery');

    list.querySelectorAll('.rrm-chips__item').forEach(function (li) {
      li.classList.remove('is-current');
      var a = li.querySelector('.rrm-chips__chip');
      if (a) a.removeAttribute('aria-current');
    });
    chip.closest('.rrm-chips__item').classList.add('is-current');
    chip.setAttribute('aria-current', 'page');
    var chipsRoot = list.closest('.rrm-chips');
    if (chipsRoot) chipsRoot.classList.add('is-loading');
    if (gallery) gallery.setAttribute('aria-busy', 'true');
    var live = list.querySelector('[data-rrm-chips-current]') || document.querySelector('[data-rrm-chips-current]');
    if (live) live.textContent = colour;

    var timedOut = false;
    var timer = setTimeout(function () { timedOut = true; window.location.href = url; }, SWAP_TIMEOUT);

    fetchSection(url, sectionId).then(function (html) {
      if (timedOut) return;
      clearTimeout(timer);
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.rrm-pdp .product');
      var current = section.querySelector('.product');
      if (!fresh || !current) throw new Error('markup');
      var freshModal = doc.querySelector('product-modal');
      var currentModal = section.querySelector('product-modal');
      current.replaceWith(fresh);
      if (freshModal && currentModal) currentModal.replaceWith(freshModal);

      /* sticky pill: colour + price from the new buy box */
      var bar = document.querySelector('[data-rrm-sticky-atc]');
      if (bar) {
        var v = bar.querySelector('[data-rrm-sticky-variant]');
        if (v) v.textContent = colour;
        var priceEl = section.querySelector('[data-rrm-atc-price]') || section.querySelector('.price__regular .price-item');
        var p = bar.querySelector('[data-rrm-sticky-price]');
        if (p && priceEl) p.textContent = priceEl.textContent.trim().replace(/\.00$/, '');
        if (bar.__rrmObserve) bar.__rrmObserve();
        if (bar.__rrmSync) bar.__rrmSync();
      }
      /* the section render carries no <title>; swap the colour segment of the existing one ("NAME | COLOUR – Shop") */
      if (/\|[^–]*–/.test(document.title)) document.title = document.title.replace(/\|[^–]*–/, '| ' + colour.toUpperCase() + ' –');
      try { history.replaceState({ rrmHandle: handle }, '', url); } catch (e) { /* ignore */ }
      bindDots(section);
      bindAtcFeedback();
      var newChip = section.querySelector('.rrm-chips__item.is-current .rrm-chips__chip');
      if (newChip && newChip.focus) { try { newChip.focus({ preventScroll: true }); } catch (e) { newChip.focus(); } }
      var g = section.querySelector('media-gallery');
      if (g) g.setAttribute('aria-busy', 'false');
      var cr = section.querySelector('.rrm-chips');
      if (cr) cr.classList.remove('is-loading');
      document.dispatchEvent(new CustomEvent('rrm:product-swapped', { detail: { handle: handle, url: url } }));
    }).catch(function () {
      clearTimeout(timer);
      if (!timedOut) window.location.href = url;
    });
  }
  /* title-row reviews link: smooth scroll to the band (scroll-margin-top on the target clears the fixed header) */
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a.rrm-rating-link[href^="#"]') : null;
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    try { history.replaceState(null, '', link.getAttribute('href')); } catch (err) { /* ignore */ }
  });

  var canSwap = ('fetch' in window) && ('DOMParser' in window) && ('replaceState' in history) && !!Element.prototype.replaceWith;
  document.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest('[data-rrm-chips] a.rrm-chips__chip[data-handle]') : null;
    if (!chip) return;
    if (chip.getAttribute('aria-current') === 'page') { e.preventDefault(); return; }
    if (chip.getAttribute('data-available') === 'false') return; /* sold-out chip made clickable in the editor: normal navigation */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    if (!canSwap) return;
    e.preventDefault();
    swapTo(chip);
  });
  function preload(e) {
    var chip = e.target.closest ? e.target.closest('[data-rrm-chips] a.rrm-chips__chip[data-handle]') : null;
    if (!chip || !canSwap || chip.getAttribute('aria-current') === 'page') return;
    var section = chip.closest('.rrm-pdp');
    if (!section) return;
    fetchSection(chip.getAttribute('data-url'), section.getAttribute('data-section')).then(preloadLead).catch(function () {});
  }
  document.addEventListener('pointerenter', preload, true);
  document.addEventListener('touchstart', preload, { capture: true, passive: true });
})();
